var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.805 5.183c.26.244.26.64 0 .884L8.609 10l4.196 3.933c.26.244.26.64 0 .884a.698.698 0 0 1-.943 0l-4.667-4.375a.598.598 0 0 1 0-.884l4.667-4.375a.698.698 0 0 1 .943 0Z",
    fill: "#666"
  })));
};
export default SvgArrowLeft;